import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _class, _descriptor;
/*
 *                     NOTICE
 *            COPYRIGHT 2020 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { LayerGroup } from "abreact/incubator/ui/layer/LayerGroup";
import { ProgressManager } from "abreact/progress/manager/ProgressManager";
import { makeObservable, observable } from "mobx";
export let ProgressActionBase = (_class = class ProgressActionBase {
  get name() {
    return this.progressAction.name;
  }
  constructor(progressAction) {
    _defineProperty(this, "progressAction", void 0);
    _initializerDefineProperty(this, "showing", _descriptor, this);
    makeObservable(this);
    this.showing = false;
    // If client doesn't supply a name, provide one.
    if (progressAction.name == null) {
      progressAction.name = "_task_" + (ProgressManager.taskNum++).toString();
    }
    this.progressAction = progressAction;
  }

  /**
   * Make the feedback go away
   */
  hideUI() {
    // Tests are constantly setting up and tearing down the LayerManager between tests. It's not unusual for a progress
    // dialog to be shown during one test, but then the test completes before the dialog is actually displayed (due
    // to the timeout used to delay its being shown). If the layer manager has been cleaned up, which we identify by
    // there being no app root, then just bail out without showing the dialog.
    if (!LayerGroup.hasDefaultAppRoot()) {
      return;
    }
    ProgressManager.singleton.hideProgressAction(this);
  }

  /**
   * Show the feedback
   */
  showUI(popupProps) {
    // Tests are constantly setting up and tearing down the LayerManager between tests. It's not unusual for a progress
    // dialog to be shown during one test, but then the test completes before the dialog is actually displayed (due
    // to the timeout used to delay its being shown). If the layer manager has been cleaned up, which we identify by
    // there being no app root, then just bail out without showing the dialog.
    if (!LayerGroup.hasDefaultAppRoot()) {
      return;
    }
    ProgressManager.singleton.showProgressAction(this, popupProps);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "showing", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
//# sourceMappingURL=ProgressActionBase.js.map
